(() => {
  if (customElements.get('bb-width-selector')) return;
  const widths = new Set(['90', '120', '135', '150', '180']);
  const parameter = 'bb_width';
  const storageKey = 'bb.collectionWidth';

  customElements.define('bb-width-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.control = this.querySelector('select');
      this.scope = this.closest('[data-bb-width-scope]');
      if (!this.control || !this.scope) return;
      this.allowedWidths = new Set([...this.control.options].map(option => option.value).filter(value => widths.has(value)));
      this.cards = [...this.scope.querySelectorAll('[data-bb-width-card]')].map(card => {
        try {
          const variants = JSON.parse(card.querySelector('[data-bb-width-variants]').textContent);
          return { card, variants: Array.isArray(variants) ? variants : [] };
        } catch {
          return { card, variants: [] };
        }
      });
      this.onChange = () => this.apply(this.control.value, true);
      this.onNavigation = () => this.apply(this.readWidth(), false);
      this.control.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onNavigation);
      window.addEventListener('pageshow', this.onNavigation);
      this.initialized = true;
      this.apply(this.readWidth(), false);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.control.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onNavigation);
      window.removeEventListener('pageshow', this.onNavigation);
      this.initialized = false;
    }

    readWidth() {
      const url = new URL(window.location.href);
      if (url.searchParams.has(parameter)) {
        const value = url.searchParams.get(parameter);
        return widths.has(value) ? value : '';
      }
      try {
        const value = sessionStorage.getItem(storageKey);
        return widths.has(value) ? value : '';
      } catch {
        return '';
      }
    }

    apply(value, updateUrl) {
      const width = this.allowedWidths.has(value) ? value : '';
      this.control.value = width;
      try {
        if (width) sessionStorage.setItem(storageKey, width);
        else if (updateUrl || !widths.has(value)) sessionStorage.removeItem(storageKey);
      } catch { /* Width links still work when storage is unavailable. */ }
      const url = new URL(window.location.href);
      if (updateUrl || (url.searchParams.has(parameter) && url.searchParams.get(parameter) !== width)) {
        if (width) url.searchParams.set(parameter, width);
        else url.searchParams.delete(parameter);
        window.history.replaceState(window.history.state, '', url);
      }
      this.scope.querySelectorAll('[data-bb-width-link], .bb-pagination a').forEach(link => {
        const url = new URL(link.href, window.location.href);
        if (width) url.searchParams.set(parameter, width);
        else url.searchParams.delete(parameter);
        link.href = url.toString();
      });
      this.cards.forEach(({ card, variants }) => {
        const variant = variants.find(item => item && item.width === (width || '90'));
        const price = card.querySelector('[data-bb-width-price]');
        const unavailable = card.querySelector('[data-bb-width-unavailable]');
        price.hidden = !variant;
        unavailable.hidden = Boolean(variant);
        if (variant) {
          card.querySelector('[data-bb-width-current]').textContent = width ? variant.price : variant.from;
          card.querySelector('[data-bb-width-compare]').textContent = variant.compare;
          card.querySelector('[data-bb-width-compare-wrap]').hidden = !variant.compare;
          card.querySelector('[data-bb-width-price-label]').textContent = (variant.compare ? price.dataset.saleLabel : price.dataset.regularLabel) + ' ';
        }
        card.querySelectorAll('[data-bb-width-product-link]').forEach(link => {
          const url = new URL(link.href, window.location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          link.href = url.toString();
        });
      });
    }
  });
})();
